<ng-container>
  <div class="modal">
    <div class="modal-body modal-body--{{size}}">
      <div class="{{backGroundColor}} {{classNameContainer}} d-flex flex-column align-items-center justify-content-center">
        <div *ngIf="showImageClose" class="modal-close" (click)="closeModalIcon()">
          <img src="{{imageClose}}" alt="close">
        </div>
        <div *ngIf="showImage && !isNoCkn && !isVerPass" class="modal-image">
          <img src="{{image}}" alt="img">
        </div>
        <div *ngIf="showImage && isNoCkn && !isVerPass" class="modal-image-2">
          <img src="{{image}}" alt="img">
        </div>
        <div *ngIf="showImage && isVerPass && !isNoCkn" class="modal-image-3">
          <img src="{{image}}" alt="img">
        </div>
        <ng-content select="[body]"></ng-content>
        <ng-content select="[footer]"></ng-content>
      </div>
    </div>
  </div>
</ng-container>
